<div class="store-cache-to-file-widget-container">
    <div class="header-container">
        <label>{{title}}</label>
    </div>
    <div class="input-container">
        <div class="tam-form-field input-info" [ngClass]="{'has-error': filePath.invalid}">
            <label class="required">Path</label>
            <input [(ngModel)]="config.filePath" class="tam-input tam-textbox" type="text" value="config.filePath"
                [formControl]="filePath">
            <div class="tam-form-help" *ngIf="filePath.invalid && filePath.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field input-info" [ngClass]="{'has-error':fileName.invalid}">
            <label class="required">File Name</label>
            <input [(ngModel)]="config.fileName" class="tam-input tam-textbox" type="text" value="config.fileName"
                [formControl]="fileName">
            <div class="tam-form-help" *ngIf="fileName.invalid && fileName.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
    </div>
    <div class="button-container">
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onSubmitClick()">
            {{'general.submit' | stringLiterals}}
        </button>
    </div>
</div>